import { HelpCircle } from "lucide-react";

import { cn } from "../lib/utils";

/**
 * Unknown device icon component
 */
export const UnknownDeviceIcon = (props: { size?: number; className?: string }) => {
  const size = props?.size || 24
  return (
    <div className={cn("flex items-center justify-center rounded-md border border-border bg-card p-1", props.className)}>
      <HelpCircle 
        size={size}
        className="text-muted-foreground"
        aria-label="unknown-device-icon"
      />
    </div>
  )
}
